const theme = {
  breakpoints: {
    mobile: '480px', // @media min-width
    tablet: '768px', // @media min-width
    laptop: '1025px', // @media min-width
    desktop: '1281px', // @media min-width
  },
  spaces: {
    // (experimental)
    // padding & margin
    space0: '0px',
    space8: '8px',
    space16: '16px',
    space24: '24px',
    space32: '32px',
    space40: '40px',
  },
  fontSizes: {
    // Use React <h1> to <h6> when designing Headings elements.
    // For better SEO as well.
    // For example
    // 1. Go to https://www.hobo-web.co.uk/headers/
    // 2. Ctrl + F, type 'utilise only one'
    // 3. Look for Headings elements use case.

    // If have any new use case, like the admin page.
    // Simply declare here.
    // Must be at least an even number.
    title1: '96px',
    title2: '60px',
    title3: '48px',
    title4: '34px',
    title5: '24px',
    title6: '20px',
    subtitle1: '16px',
    subtitle2: '14px',
    body1: '16px',
    body2: '14px',
    button1: '18px',
    button2: '14px',
    caption: '12px',
    overline: '10px', // All caps
    adminCardValue: '48px',

    iconMenu: '18px',
    iconUpload: '24px',

    formTitle: '32px',
    formSubtitle: '16px',
    formLabel: '18px',
    formSmallLabel: '13px',
    formTableInput: '16px',
    formInput: '14px',

    // No longer using this. Remain for backward comp.....
    // extraSmall: '10.72px', // 0.67em h6
    // small: '13.28px', // 0.83em h5
    // normal: '16px', // 1em h4
    // large: '18.72px', // 1.17em h3
    // extraLarge: '24px', // 1.5em h2
    // header: '32px', // 2em h1
  },
  fontWeights: {
    light: 100,
    normal: 400,
    medium: 500,
    bold: 700,
  },
  lineHeights: {
    // (experimental)
    solid: 1,
    title: 1.25,
    copy: 1.5,
  },
  letterSpacings: {
    // (experimental)
    normal: 'normal',
    tracked: '0.1em',
    tight: '-0.05em',
    mega: '0.25em',
  },
  fonts: {
    // (experimental)
    serif: 'athelas, georgia, times, serif',
    sansSerif:
      '-apple-system, BlinkMacSystemFont, "avenir next", avenir, "helvetica neue", helvetica, ubuntu, roboto, noto, "segoe ui", arial, sans-serif',
  },
  colors: {
    /**
     * primary: '#00b624'
     * hover,focus: '#1fc23a'
     * active: '#008f21'
     */

    // Header
    header: '#ffffff',
    headerBackground: '#ffffff',
    headerBorder: '#f4f5f6',
    headerText: '#ffffff',

    // Header Link
    headerLink: '#ffffff',
    headerLinkBackground: '#00b624',
    headerLinkBorder: '#00b624',
    headerLinkHoverBackground: '#1fc23a',
    headerLinkHoverBorder: '#1fc23a',
    headerLinkHover: '#ffffff',
    headerLinkActiveBackground: '#008f21',
    headerLinkActiveBorder: '#008f21',
    headerLinkActive: '#ffffff',
    headerLinkText: '#ffffff',

    // Header Button
    headerButton: '#ffffff',
    headerButtonBackground: '#ffffff',
    headerButtonBorder: '#ffffff',
    headerButtonHoverBorder: '#ffffff',
    headerButtonHover: '#ffffff',
    headerButtonText: '#ffffff',

    // Sider
    sider: '#212121',
    siderBorder: '#f4f5f6',

    // Page
    page: '#ffffff',
    pageBackground: '#eceff1', // materialbluegray50
    pageBorder: '#ffffff',
    pageText: '#ffffff',

    // Container
    containerBackground: '#ffffff', // white

    // Call-to-Action Button
    callToActionButton: '#ffffff',
    callToActionButtonBackground: '#ffffff',
    callToActionButtonBorder: '#ffffff',
    callToActionButtonHoverBorder: '#ffffff',
    callToActionButtonHover: '#ffffff',
    callToActionButtonText: '#ffffff',

    // Form Primary Button (aka Solid Button)
    formPrimaryButton: '#ffffff',
    formPrimaryButtonBackground: '#88d453',
    formPrimaryButtonBorder: '#88d453',
    formPrimaryButtonHoverBorder: '#b2f77f',
    formPrimaryButtonHover: '#b2f77f',
    formPrimaryButtonText: '#ffffff',

    // Form Secondary Button (aka Ghost Button)
    formSecondaryButton: '#ffffff',
    formSecondaryButtonBackground: '#ffffff',
    formSecondaryButtonBorder: '#ffffff',
    formSecondaryButtonHoverBorder: '#ffffff',
    formSecondaryButtonHover: '#ffffff',
    formSecondaryButtonText: '#ffffff',

    // Footer
    footer: '#ffffff',
    footerBackground: '#1B5E20',
    footerBorder: '#ffffff',
    footerText: '#ffffff',

    // Footer Link
    footerLink: '#ffffff',
    footerLinkBackground: '#ffffff',
    footerLinkBorder: '#ffffff',
    footerLinkHoverBorder: '#ffffff',
    footerLinkHover: '#ffffff',
    footerLinkText: '#ffffff',

    black: '#000000',

    white: '#ffffff',

    materialred50: '#ffebee',
    materialred100: '#ffcdd2',
    materialred200: '#ef9a9a',
    materialred300: '#e57373',
    materialred400: '#ef5350',
    materialred500: '#f44336',
    materialred600: '#e53935',
    materialred700: '#d32f2f',
    materialred800: '#c62828',
    materialred900: '#b71c1c',
    materialreda100: '#ff8a80',
    materialreda200: '#ff5252',
    materialreda400: '#ff1744',
    materialreda700: '#d50000',

    materialpink50: '#fce4ec',
    materialpink100: '#f8bbd0',
    materialpink200: '#f48fb1',
    materialpink300: '#f06292',
    materialpink400: '#ec407a',
    materialpink500: '#e91e63',
    materialpink600: '#d81b60',
    materialpink700: '#c2185b',
    materialpink800: '#ad1457',
    materialpink900: '#880e4f',
    materialpinka100: '#ff80ab',
    materialpinka200: '#ff4081',
    materialpinka400: '#f50057',
    materialpinka700: '#c51162',

    materialpurple50: '#f3e5f5',
    materialpurple100: '#e1bee7',
    materialpurple200: '#ce93d8',
    materialpurple300: '#ba68c8',
    materialpurple400: '#ab47bc',
    materialpurple500: '#9c27b0',
    materialpurple600: '#8e24aa',
    materialpurple700: '#7b1fa2',
    materialpurple800: '#6a1b9a',
    materialpurple900: '#4a148c',
    materialpurplea100: '#ea80fc',
    materialpurplea200: '#e040fb',
    materialpurplea400: '#d500f9',
    materialpurplea700: '#aa00ff',

    materialdeeppurple50: '#ede7f6',
    materialdeeppurple100: '#d1c4e9',
    materialdeeppurple200: '#b39ddb',
    materialdeeppurple300: '#9575cd',
    materialdeeppurple400: '#7e57c2',
    materialdeeppurple500: '#673ab7',
    materialdeeppurple600: '#5e35b1',
    materialdeeppurple700: '#512da8',
    materialdeeppurple800: '#4527a0',
    materialdeeppurple900: '#311b92',
    materialdeeppurplea100: '#b388ff',
    materialdeeppurplea200: '#7c4dff',
    materialdeeppurplea300: '#651fff',
    materialdeeppurplea400: '#6200ea',

    materialindigo50: '#e8eaf6',
    materialindigo100: '#c5cae9',
    materialindigo200: '#9fa8da',
    materialindigo300: '#7986cb',
    materialindigo400: '#5c6bc0',
    materialindigo500: '#3f51b5',
    materialindigo600: '#3949ab',
    materialindigo700: '#303f9f',
    materialindigo800: '#283593',
    materialindigo900: '#1a237e',
    materialindigoa100: '#8c9eff',
    materialindigoa200: '#536dfe',
    materialindigoa400: '#3d5afe',
    materialindigoa700: '#304ffe',

    materialblue50: '#e3f2fd',
    materialblue100: '#bbdefb',
    materialblue200: '#90caf9',
    materialblue300: '#64b5f6',
    materialblue400: '#42a5f5',
    materialblue500: '#2196f3',
    materialblue600: '#1e88e5',
    materialblue700: '#1976d2',
    materialblue800: '#1565c0',
    materialblue900: '#0d47a1',
    materialbluea100: '#82b1ff',
    materialbluea200: '#448aff',
    materialbluea400: '#2979ff',
    materialbluea700: '#2962ff',

    materiallightblue50: '#e1f5fe',
    materiallightblue100: '#b3e5fc',
    materiallightblue200: '#81d4fa',
    materiallightblue300: '#4fc3f7',
    materiallightblue400: '#29b6f6',
    materiallightblue500: '#03a9f4',
    materiallightblue600: '#039be5',
    materiallightblue700: '#0288d1',
    materiallightblue800: '#0277bd',
    materiallightblue900: '#01579b',
    materiallightbluea100: '#80d8ff',
    materiallightbluea200: '#40c4ff',
    materiallightbluea400: '#00b0ff',
    materiallightbluea700: '#0091ea',

    materialcyan50: '#e0f7fa',
    materialcyan100: '#b2ebf2',
    materialcyan200: '#80deea',
    materialcyan300: '#4dd0e1',
    materialcyan400: '#26c6da',
    materialcyan500: '#00bcd4',
    materialcyan600: '#00acc1',
    materialcyan700: '#0097a7',
    materialcyan800: '#00838f',
    materialcyan900: '#006064',
    materialcyana100: '#84ffff',
    materialcyana200: '#18ffff',
    materialcyana400: '#00e5ff',
    materialcyana700: '#00b8d4',

    materialteal50: '#e0f2f1',
    materialteal100: '#b2dfdb',
    materialteal200: '#80cbc4',
    materialteal300: '#4db6ac',
    materialteal400: '#26a69a',
    materialteal500: '#009688',
    materialteal600: '#00897b',
    materialteal700: '#00796b',
    materialteal800: '#00695c',
    materialteal900: '#004d40',
    materialteala100: '#a7ffeb',
    materialteala200: '#64ffda',
    materialteala400: '#1de9b6',
    materialteala700: '#00bfa5',

    materialgreen50: '#e8f5e9',
    materialgreen100: '#c8e6c9',
    materialgreen200: '#a5d6a7',
    materialgreen300: '#81c784',
    materialgreen400: '#66bb6a',
    materialgreen500: '#4caf50',
    materialgreen600: '#43a047',
    materialgreen700: '#388e3c',
    materialgreen800: '#2e7d32',
    materialgreen900: '#1b5e20',
    materialgreena100: '#b9f6ca',
    materialgreena200: '#69f0ae',
    materialgreena400: '#00e676',
    materialgreena700: '#00c853',

    materiallightgreen50: '#f1f8e9',
    materiallightgreen100: '#dcedc8',
    materiallightgreen200: '#c5e1a5',
    materiallightgreen300: '#aed581',
    materiallightgreen400: '#9ccc65',
    materiallightgreen500: '#8bc34a',
    materiallightgreen600: '#7cb342',
    materiallightgreen700: '#689f38',
    materiallightgreen800: '#558b2f',
    materiallightgreen900: '#33691e',
    materiallightgreena100: '#ccff90',
    materiallightgreena200: '#b2ff59',
    materiallightgreena400: '#76ff03',
    materiallightgreena700: '#64dd17',

    materiallime50: '#f9fbe7',
    materiallime100: '#f0f4c3',
    materiallime200: '#e6ee9c',
    materiallime300: '#dce775',
    materiallime400: '#d4e157',
    materiallime500: '#cddc39',
    materiallime600: '#c0ca33',
    materiallime700: '#afb42b',
    materiallime800: '#9e9d24',
    materiallime900: '#827717',
    materiallimea100: '#f4ff81',
    materiallimea200: '#eeff41',
    materiallimea400: '#c6ff00',
    materiallimea700: '#aeea00',

    materialyellow50: '#fffde7',
    materialyellow100: '#fff9c4',
    materialyellow200: '#fff59d',
    materialyellow300: '#fff176',
    materialyellow400: '#ffee58',
    materialyellow500: '#ffeb3b',
    materialyellow600: '#fdd835',
    materialyellow700: '#fbc02d',
    materialyellow800: '#f9a825',
    materialyellow900: '#f57f17',
    materialyellowa100: '#ffff8d',
    materialyellowa200: '#ffff00',
    materialyellowa400: '#ffea00',
    materialyellowa700: '#ffd600',

    materialamber50: '#fff8e1',
    materialamber100: '#ffecb3',
    materialamber200: '#ffe082',
    materialamber300: '#ffd54f',
    materialamber400: '#ffca28',
    materialamber500: '#ffc107',
    materialamber600: '#ffb300',
    materialamber700: '#ffa000',
    materialamber800: '#ff8f00',
    materialamber900: '#ff6f00',
    materialambera100: '#ffe57f',
    materialambera200: '#ffd740',
    materialambera400: '#ffc400',
    materialambera700: '#ffab00',

    materialorange50: '#fff3e0',
    materialorange100: '#ffe0b2',
    materialorange200: '#ffcc80',
    materialorange300: '#ffb74d',
    materialorange400: '#ffa726',
    materialorange500: '#ff9800',
    materialorange600: '#fb8c00',
    materialorange700: '#f57c00',
    materialorange800: '#ef6c00',
    materialorange900: '#e65100',
    materialorangea100: '#ffd180',
    materialorangea200: '#ffab40',
    materialorangea400: '#ff9100',
    materialorangea700: '#ff6d00',

    materialdeeporange50: '#fbe9e7',
    materialdeeporange100: '#ffccbc',
    materialdeeporange200: '#ffab91',
    materialdeeporange300: '#ff8a65',
    materialdeeporange400: '#ff7043',
    materialdeeporange500: '#ff5722',
    materialdeeporange600: '#f4511e',
    materialdeeporange700: '#e64a19',
    materialdeeporange800: '#d84315',
    materialdeeporange900: '#bf360c',
    materialdeeporangea100: '#ff9e80',
    materialdeeporangea200: '#ff6e40',
    materialdeeporangea400: '#ff3d00',
    materialdeeporangea700: '#dd2c00',

    materialbrown50: '#efebe9',
    materialbrown100: '#d7ccc8',
    materialbrown200: '#bcaaa4',
    materialbrown300: '#a1887f',
    materialbrown400: '#8d6e63',
    materialbrown500: '#795548',
    materialbrown600: '#6d4c41',
    materialbrown700: '#5d4037',
    materialbrown800: '#4e342e',
    materialbrown900: '#3e2723',

    materialgray50: '#fafafa',
    materialgray100: '#f5f5f5',
    materialgray200: '#eeeeee', // For background
    materialgray300: '#e0e0e0',
    materialgray400: '#bdbdbd',
    materialgray500: '#9e9e9e',
    materialgray600: '#757575', // For normal text and bottom logo
    materialgray700: '#616161',
    materialgray800: '#424242',
    materialgray900: '#212121', // For title text

    materialbluegray50: '#eceff1',
    materialbluegray100: '#cfd8dc',
    materialbluegray200: '#b0bec5',
    materialbluegray300: '#90a4ae',
    materialbluegray400: '#78909c',
    materialbluegray500: '#607d8b',
    materialbluegray600: '#546e7a',
    materialbluegray700: '#455a64',
    materialbluegray800: '#37474f',
    materialbluegray900: '#263238',

    lightrosequartzred: '#ffecec',
    plainrosequartzred: '#ffdcdb',
    darkrosequartzred: '#f7cac9',

    lightserenityblue: '#e6eeff',
    plainserenityblue: '#b4c8ea',
    darkserenityblue: '#92a8d1',

    lightlivingcoralred: '#ef9a9a',
    plainlivingcoralred: '#ef5350',
    darklivingcoralred: '#e53935',

    pastelred: '#ffb3ba',
    pastelorange: '#ffdfba',
    pastelyellow: '#ffffba',
    pastelgreen: '#baffc9',
    pastelblue: '#bae1ff',

    googleplusred: '#dd4b39',
    facebookblue: '#3b5999',
    cornflowerblue: '#55acee',
    facebookactivegreen: '#469a1f',
  },
};

export default theme;
